module.exports = __webpack_public_path__ + "static/scale-model-of-pasadena-california-25b41928adb47052d61317e87775c69c.png";